import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { clearErrors, } from '../../actions';
import { ValidarLogin, ValidarEmisor } from '../../util';
import { documentTypeEnum } from '../../enum';
import NuevoDocumento from '../nuevoDocumento/NuevoDocumento';
import RenderHeader from '../shared/RenderHeader';


const CrearFactura = (props) => {
  const { token } = ValidarLogin(props);
  const { emisor } = ValidarEmisor(props);

  useEffect(() => {
    props.clearErrors();
  }, [emisor]);

  if (token === null || emisor === null) {
    return <Redirect to='/login' />;
  }

  return (
    <div className="ui segment container-facturas">

      <RenderHeader titulo="FACTURA ELECTRÓNICA" />

      <div className="sixteen wide column no-padding">
        {
          emisor && <NuevoDocumento
            token={token?.access_token}
            emisor={emisor}
            docType={documentTypeEnum.Factura}
          />
        }
      </div>

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    loginState: state.loginState,
    emisorState: state.emisorState,
  };
}

export default connect(mapStateToProps,
  {
    clearErrors,
  })(CrearFactura);